import * as CognitoIdentity from 'amazon-cognito-identity-js';

export enum CognitoUserAttributeName {
    Title = 'custom:title',
    FirstName = 'given_name',
    LastName = 'family_name',
    CompanyName = 'custom:companyName',
    PhoneNumber = 'phone_number',
    Email = 'email',
    PartnerSource = 'custom:partnerSource',
    UtmData = 'custom:data'
}

export function createCognitoUserAttribute(
    name: CognitoUserAttributeName,
    value: string
): CognitoIdentity.CognitoUserAttribute {
    return new CognitoIdentity.CognitoUserAttribute({ Name: name, Value: value });
}

export function unawaited<T>(_promise: Promise<T>): void {}


// WEBPACK FOOTER //
// ./src/webportal/utils/cognito.ts